import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAlertTriangle = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 1.5,
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsx("path", { d: "M13.6 1.8C13.2.9 12.1.5 11.2 1c-.4.2-.6.5-.8.8L.9 21.1c-.4.8-.1 1.7.7 2 .2.1.4.2.7.2h19.5c.8 0 1.5-.7 1.5-1.5 0-.2-.1-.5-.2-.7L13.6 1.8zM12 15.8V8.3" }), /* @__PURE__ */ _jsx("circle", {
		cx: 12,
		cy: 19.1,
		r: .4
	})]
});
export { SvgAlertTriangle as ReactComponent };
